<template>
  <notifications class="hide-on-print" position="top left" :width="320" :speed="500">
    <template slot="body" slot-scope="{item, close}">
      <div class="vue-notify"
           :class="item.type"
      >
        <i :class="['vue-notify__icon', icons[item.type] || icons.info]"/>
        <div class="vue-notify--content">
            <div class="vue-notify__title">
              {{ $t(item.title) }} {{ item.duration }}
            </div>
            <div class="vue-notify__text">
              {{ $t(item.text) }}
              <!-- NB! -->
              <!-- To pass link you should place `data` obj into $notify method -->
              <!-- with two props `link-to` and `link-text` (optional) -->
              <!-- e.g. data: {linkTo: 'google.com' or {name: 'mainPage'}, linkText: 'awesome link'} -->
              <span @click="close">
                <router-link v-if="item.data && item.data.linkTo" :to="item.data.linkTo" :target="item.data.target || '_self'">
                  {{ $t(item.data.linkText || 'link') }}
                </router-link>
              </span>
              <b-link v-if="item.data && item.data.refreshShown" @click.prevent="$router.go()">
                {{ $t(item.data.refreshText || 'refresh the page') }}
              </b-link>
              <template v-if="item.data && item.data.messages">
                <div v-for="(message, index) in item.data.messages" :key="index">
                  {{ $t(message.text) }}
                  <b-link v-if="message.linkTo" :to="message.linkTo">
                    {{ $t(message.linkText || 'link') }}
                  </b-link>
                </div>
              </template>
            </div>
          </div>
        <!-- NB! -->
        <!-- To show Close button you should place `closeHidden` into `data` obj into $notify method -->
        <!-- e.g. data: {closeHidden: false} -->
        <app-icon-with-action
          v-if="item.data && !item.data.closeHidden"
          class="vue-notify__close"
          :hover-effect="false"
          @click="close"
        >
          <i class="vue-notify__close-icon fal fa-times-circle"></i>
        </app-icon-with-action>
      </div>
    </template>
  </notifications>
</template>
<script>
import AppIconWithAction from './AppIconWithAction'

export default {
  name: 'AppNotification',
  components: { AppIconWithAction },
  data () {
    return {
      icons: {
        error: 'fas fa-octagon-xmark',
        success: 'fas fa-circle-check',
        info: 'fas fa-square-info',
        warn: 'fas fa-triangle-exclamation'
      }
    }
  }
}
</script>
<style lang="scss">
.vue-notification-group {
  margin-top: 1.5rem;

  .vue-notification-wrapper {

    .vue-notify {
      opacity: 0.95;
      box-shadow: 6px 6px 6px #0000007A;
      margin-bottom: .625rem;
      box-sizing: border-box;
      border: 0;
      border-radius: 0 4px 4px 0;
      width: calc(100% - 1rem);
      max-height: 20rem;
      overflow-y: scroll;
      font-size: .875rem;
      line-height: 1.25rem;
      padding: 1rem;
      color: $system-color-info;
      background: $system-color-info-light;
      transition: all ease 0.5s;
      position: relative;

      &__icon {
        position: absolute;
        inset-block-start: 1rem;
        font-size: 1.5rem;
        width: 1.5rem;
      }

      &--content {
        padding: 0 2rem;
        overflow-wrap: break-word;
        max-width: 17rem;
      }

      &__title {
        text-transform: uppercase;
        font-weight: bold;
      }

      &__text {
        color: $gray-600;
      }

      &.error {
        background: $system-color-error-light;
        color: $system-color-error;
      }

      &.success {
        background: $system-color-success-light;
        color: $system-color-success;
      }

      &.warn {
        background: $system-color-warning-light;
        color: $system-color-warning;
      }

      &__close {
        position: absolute;
        inset-block-start: 1rem;
        inset-inline-end: 1rem;
        color: $gray;
        width: 1.25rem;
        opacity: 1;
        font-size: 1.25rem;
        cursor: pointer;

        &-icon {
          color: inherit !important;
        }

        &:hover {
          color: var(--scheme-top-nav-txt ,inherit) !important;
        }
      }

      &:hover {
        box-shadow: 6px 6px 6px;
      }
    }
  }
}
</style>
